(() => {
  if (customElements.get('wallify-size-guide')) return;
  customElements.define('wallify-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.buttons = [...this.querySelectorAll('[data-size-value]')];
      this.sizes = this.buttons.map(button => {
        const match = button.dataset.sizeValue.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i);
        if (!match) { button.hidden = true; return null; }
        return {button,width:Number(match[1].replace(',','.')),height:Number(match[2].replace(',','.'))};
      }).filter(Boolean);
      if (!this.sizes.length) { this.hidden = true; return; }
      this.querySelector('[data-size-guide-open]').addEventListener('click', () => {
        const section = this.closest('.section-main-product');
        const selected = section?.querySelector('.wallify-size-choice select')?.value;
        this.draw(this.sizes.find(size => size.button.dataset.sizeValue === selected) || this.sizes[0]);
        this.dialog.showModal();
      });
      this.querySelector('[data-size-guide-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.sizes.forEach(size => size.button.addEventListener('click', () => this.draw(size)));
      this.draw(this.sizes[0]);
    }
    disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); }
    draw(size) {
      const scale = 260 / Math.max(174,size.height,size.width);
      const width = size.width * scale, height = size.height * scale;
      const rectangle = this.querySelector('[data-size-guide-poster]');
      rectangle.setAttribute('x',315 - width / 2);
      rectangle.setAttribute('y',292 - height);
      rectangle.setAttribute('width',width);
      rectangle.setAttribute('height',height);
      const label = size.button.dataset.sizeValue.split(/cm/i)[0].trim() + ' cm';
      this.querySelector('[data-size-guide-caption]').textContent = label;
      this.querySelector('[data-size-guide-svg]').setAttribute('aria-label',this.dataset.comparison.replace('{size}',label));
      this.sizes.forEach(entry => entry.button.setAttribute('aria-pressed',String(entry === size)));
    }
  });
})();
